import type { BranchId } from "~/branching/model/branch";

export const routes = {
  Root: "/",
  SignIn: "/sign-in",
  Systems: "/systems",
  SystemsDashboard: "/systems-dashboard",
  SystemHome: "/systems-dashboard/:systemId",
  SystemHomeDirectory: "directory/:nodeId?",
  SystemHomeWorkflows: "workflows",
  SystemHomeBranches: "branches",
  SystemHomeCommits: "commits",
  SystemHomeChangeRequests: "change-requests",
  SystemHomeChangeRequestDetail: "change-requests/:id",
  SystemHomeCreateChangeRequest: "change-requests/new",
  SystemHomeBranchScope: "bid/:branchId",
  Files: "/files",
  Jobs: "/jobs",
  JobDetails: "/jobs/:jobId",
  Admin: "/admin",
  Settings: "/settings",
  Comment: "/comment",
  FunctionAuthCallback: "/callback",
  NotFound: "/404",
  Documentation: "/documentation",
  MagicDocs: "/magic-docs",
  Upload: "/upload",
  AdminUsers: "/admin/users",
  AdminFunctions: "/admin/functions",
  AdminControlTags: "/admin/control-tags",
  Agents: "/agents",
  Notifications: "/notifications",
  AdminAppIntegrations: "/admin/app-integrations",
  AdminIntegrations: "/admin/integrations",
  AdminInfosecLevels: "/admin/infosec-levels",
  AdminInfosec: "/admin/infosec",
  AdminUsage: "/admin/usage",
  AdminCompatibility: "/admin/compatibility",
  AdminAiSettings: "/admin/ai-settings",
  AdminAiModels: "/admin/ai-models",
  AdminConnectedSources: "/admin/connected-sources",
  AdminSecureConnections: "/admin/secure-connections",
  AdminSecureConnectionSyncStatus: "/admin/secure-connections/:kind/:connectionId/sync-status",
  CreateChangeRequest: "/systems/:systemId/change-requests/new",
  ChangeRequestDetail: "/systems/:systemId/change-requests/:id",
  /**
   * `/systems/{systemId}/…` — branch path, `…/history`, `…/history/{shortId}`, and legacy
   * `configId/snapshotId/…` sit in a single `*` (see `parseSystemRouteTail` in `System/`).
   */
  SystemDetails: "/systems/:systemId/*",
  Artifact: "/artifact/:artifactId/:artifactVersionId?",
  FilesUnparentedArtifact: "/files/artifact/:artifactId/:artifactRevisionId?",
  CommentDetails: "/comment/:commentId",
  Search: "/search",
} as const;

export const buildSystemWorkflowLogRoute = (systemId: string, entryId?: string, branchId?: BranchId | null) => {
  const branchPrefix = branchId ? `bid/${encodeURIComponent(branchId)}/` : "";
  return `/systems-dashboard/${systemId}/${branchPrefix}workflows${entryId ? `?entry=${entryId}` : ""}`;
};

export type RouteKeys = keyof typeof routes;
export type RouteValues = (typeof routes)[keyof typeof routes];
